import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateIsNotEmpty } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "OpenAI",
  category: AgentCategory.ASSISTANT,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#cccccc",
  description: "Connect your OpenAI managed agent to research, plan, and complete tasks",
  descriptionMarkdown: `## Overview

Assign a task to OpenAI and Dart will start a session with the managed agent you already configured in OpenAI. Replies appear in the task, and follow-up comments continue the same session.

## Setup guide

1. Create and configure your managed agent in OpenAI using the [setup guide](https://developers.openai.com/api/docs/guides/agents-api/configuration)
2. Create an OpenAI API key with access to that agent
3. Paste your API key and agent ID below
4. If your agent needs a specific hosted environment template or vaults, enter their IDs below
5. Assign a task to your agent from Dart`,
  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "OpenAI API key",
      placeholder: "Your OpenAI API key",
      validate: validateIsNotEmpty,
    },
    {
      key: "agentId",
      type: "text",
      label: "Agent ID",
      placeholder: "Your OpenAI agent ID",
      validate: validateIsNotEmpty,
    },
    {
      key: "environmentTemplateId",
      type: "text",
      label: "Environment template ID",
      placeholder: "Your OpenAI environment template ID",
      optional: true,
    },
    {
      key: "vaultIds",
      type: "text",
      label: "Vault IDs (comma or newline separated)",
      placeholder: "Your OpenAI vault IDs",
      optional: true,
    },
  ],
};

export default config;
